import { render } from "./PlayAllWords.component.vue?vue&type=template&id=76ef725c"
import script from "./PlayAllWords.component.vue?vue&type=script&lang=js"
export * from "./PlayAllWords.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__